import React from "react";

import { useTranslation } from "react-i18next";

import { BUTTON_VARIANTS } from "../button/Button";
import Modal from "../modal/ConfirmModal";

import type { JSX } from "react";

interface AdsParamsModalProps {
  searchParams: URLSearchParams;
  isOpen: boolean;
  onClose: () => void;
}

export default function AdsParamsModal({
  searchParams,
  isOpen,
  onClose,
}: AdsParamsModalProps): JSX.Element | null {
  const { t } = useTranslation("editor-utils");

  searchParams.sort();

  const paramsArray = Array.from(searchParams);

  const renderParams = (): JSX.Element[] =>
    paramsArray.map(([key, value]) => (
      <div key={key} className="flex p-[0.46875rem]">
        <span>{key}&nbsp;:&nbsp;</span>
        <code className="bg-primary/10 text-primary rounded px-1 py-0.5">
          {value || t("noValue", { ns: "editor-utils" })}
        </code>
      </div>
    ));

  const modalActions = [
    {
      label: t("close"),
      onClick: onClose,
      buttonVariant: BUTTON_VARIANTS.SECONDARY,
    },
  ];
  return (
    <Modal
      actions={modalActions}
      isOpen={isOpen}
      onClose={onClose}
      title={t("adParams", { ns: "editor-content" })}
    >
      <div className="divide-y">{renderParams()}</div>
    </Modal>
  );
}
